<template>
  <div class="dialogue-list" v-if="bodyShow">
    <h2 class="h2">自我对话</h2>
    <!-- pc端书写 -->
    <p class="pc" @click="toPcHandle()">点击此处查看“PC端书写”登录操作流程<span>?</span></p>
    <!-- 自由对话page -->
    <div v-for="(item,index) in list" :key="index" >
      <div :class="['textarea-group',saveBool?'on':'',list.length==(index+1)?'none-border':'']" v-if="item.type=='textarea'">
        <div class="h3" v-html="item.question"></div>
        <textarea v-if="!saveBool" @input="inputChange()" v-model="item.val" :placeholder="(item.config && item.config.placeholder[0])?item.config.placeholder[0]:''"></textarea>
        <span v-if="!saveBool" class="num">{{item.val.length}} 字</span>
        <!-- 已提交 -->
        <div v-if="saveBool" class="save-group">
          {{item.val}}
        </div>
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="submitBtn" >
      <div v-if="saveBool" class="submit-group" >
        <a  class="on" @click="saveBool=false" >还有话说</a>
        <a  class="on" @click="$router.go(-1)" >返回任务</a>
      </div>
      <a v-else :class="[bool?'on':'']" @click="doSubmit()" >提交</a>
    </div>
    <!-- 提示进入手机端书写还是pc端书写 -->
    <van-popup v-model="dia_show">
      <div class="pop_dia">
        <img src="@a/pop_dioa.png" alt="" />
        <h2>为了你能够有舒适的书写体验,我们建议你通过PC端完成自我对话的书写<span>点击“PC端书写”查看登录操作流程</span></h2>
        <div class="href">
          <a @click="dia_show=false">手机端书写</a>
          <router-link :to="'/course_dialogue_pc?fullPath='+encodeURIComponent(fullPath)">PC端书写</router-link>
        </div>
      </div>
    </van-popup>
    <!-- 鼓励语 -->
    <div v-if="str_length>=test.tips_show" :title="test.tips" class="Encourage-language text-ellipsis">
      {{test.tips}}
    </div>
  </div>
</template>
<script>
import {
  taskTest,
  testSubmit
} from "@/api/course"
import { getStorage, setStorage } from "@/utils/tools"
import { shareCon} from "@/utils/wxconfig"
export default {
  data() {
      return {
        bodyShow: false,
        data: {},
        dia_show: true,
        fullPath: '',
        list:[],
        subfield:[],
        bool:false,
        test:{},
        str_length:0,
        saveBool:false
      }
    },
    methods: {
      /*
       *@Description: 跳转pc端填写
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-09 18:07:07
      */
      toPcHandle(){
        this.$router.push('/course_dialogue_pc?fullPath='+encodeURIComponent(this.fullPath));
      },
      /*
       *@Description: 提交数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-26 14:18:22
      */
      doSubmit(){
        if(!this.bool){
          this.$toast('请检查数据是否为空！');
        }else{
          this.$toast.loading({
            mask: true,
            message: "提交中..."
          });
          let arr = [];
          this.list.forEach((item,index)=>{
            arr.push({
              id:item.id,
              content:item.val
            });
          })
          testSubmit({
            cid:this.$route.query.cid,
            field:arr
          }).then((data)=>{
            if (data.code === 10002) {
              this.$toast(data.data.msg);
              return
            }
            this.$toast.clear();
            this.$toast.success({
              duration: 1000,       // 持续展示 toast
              message:data.msg,
              onClose:()=>{
                this.pullData();
              }
            });
          });
        }
      },
      /*
       *@Description: 改变值
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-26 12:26:32
      */
      inputChange(){
        this.$forceUpdate();
        this.validationHandle();
      },
      /*
       *@Description: 验证数据是否正确
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-26 12:21:22
      */
      validationHandle(bool){
        let b= true;
        let len = 0;
        this.list.forEach((item,index)=>{
          if(bool){
            if(this.subfield && this.subfield.length>0){
              this.subfield.forEach((sitem,sindex)=>{
                if(item.id==sitem.field_id){
                  item['val']=sitem.content;
                }
                
              })
            }else{
              item['val']="";
              b=false;
            }
          }else{
            len+=item['val'].length;
            if(!item['val']){
              b=false;
            }
          }
        });
        this.str_length = len;
        this.bool = b;
      },
      /*
       *@Description: 初始化请求数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-26 11:26:44
      */
      pullData() {
        // loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        taskTest({
            cid: parseInt(this.$route.query.cid),
            testid: this.$route.query.testid,
            taskid: this.$route.query.taskid
          })
          .then((data) => {
            let storage = getStorage(this.$route.path, 'dia_show');
            this.dia_show = storage==1 || !storage?true:false;
            this.$toast.clear();
            if (data.code === 10002) {
              this.$toast(data.data.msg);
              return
            }
            this.data = data;
            this.saveBool = data.subfield && data.subfield.length>0?true:false;
            this.subfield = data.subfield;
            this.list = data.list;
            this.test = data.test;
            this.validationHandle(true);
            this.bodyShow = true;
            this.fullPath = this.$route.fullPath;
            this.$toast.clear();
          })
      }
    },
    watch:{
      /*
       *@param: newVal 新改变值,oldVal未改变前值
       *@Description: 存储弹出书写设备提示（手机端还是pc端）
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-09 16:29:02
      */
      dia_show(newVal,oldVal){
        setStorage(this.$route.path, 'dia_show', newVal?1:2);
      }
    },
    created() {
      this.pullData();
      shareCon("course", this);
    }
}
</script>
<style lang="scss" scope>
body{
  background: #f0f0f0;
}
.dialogue-list{
  padding: 40px 0 128px;
  .pc{
    color: #F57F17;
    font-size: 24px;
    margin-bottom: 47px;
    text-decoration: underline;
    display: flex;
    align-items: center;
    padding: 0 30px;
    span{
      display: flex;
      width: 24px;
      height:24px;
      font-size: 20px;
      justify-content: center;
      align-items: center;
      background-color: #F57F17;
      color: #ffffff;
      border-radius: 50%;
      overflow: hidden;
      margin-left: 8px;
    }
  }
  .h2{
    font-size: 36px;
    color: #333;
    margin-bottom: 40px;
    text-align: center;
  }
  .textarea-group{
    padding: 0 30px;
    margin-bottom: 50px;
    position: relative;
    .h3{
      margin-bottom: 20px;
    }
    textarea{
      font-size: 26px;
      border-radius:8px;
      height: 244px;
      line-height: 40px;
      padding: 22px;
      border: none;
      width: 100%;
      resize: none;
    }
    .save-group{
      font-size: 26px;
      color: #333;
    }
    span.num{
      position: absolute;
      bottom: 14px;
      right: 43px;
      color: #999999;
    }
  }
  .textarea-group.on{
    margin-bottom: 40px;
    padding-bottom: 40px;
    border-bottom: 1px solid #CCCCCC;
  }
  .textarea-group.on.none-border{
    border-bottom: none;
  }
  .submitBtn{
    line-height: 98px;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    text-align:  center;
    font-size: 34px;
    color: #fff;
    background-color: #cccccc;
    a{
      display: block;
    }
    .on{
      color: #fff;
      background-color: #EB5032;
    }
  }
  .submit-group{
    display: flex;
    a{
      flex: 1;
      &:last-child{
        border-left: 1px solid #ffffff;
        box-sizing: border-box;
      }
    }
  }
  .Encourage-language{
    line-height: 80px;
    font-size: 26px;
    color: #fff;
    background-color: rgba($color: #000000, $alpha: .5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding:0 30px;
    box-sizing: border-box;
  }
}

// 弹窗
.pop_dia {
  width: 600px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding-top: 100px;
  text-align: center;
  img {
    width: 430px;
    height: 230px;
  }
  h2 {
    margin-top: 80px;
    font-size: 34px;
    color: #333;
    padding: 0 36px;
    text-align: justify;
    line-height: 50px;
    span {
      font-size: 20px;
      color: #999;
    }
  }
  .href {
    border-top: 1px solid #ccc;
    margin-top: 100px;
    display: flex;
    line-height: 100px;
    a {
      width: 100%;
      border-right: 1px solid #ccc;
      font-size: 34px;
      color: #999;
    }
    a:last-child {
      border-right: none;
      color: #F57F17;
    }
  }
}
</style>
